import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";

interface IProps {
    isOpen: boolean;
    overlayVariant?: IModalOverlayVariant;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowLoadingModal = (props: IProps) => {
    const {isOpen, overlayVariant, zIndex} = props;

    return (
        <Modal isOpen={isOpen} className={modalStyle} showCloseButton={false} overlayVariant={overlayVariant} {...(zIndex === undefined ? {} : {zIndex})}>
            <Modal.Content className={loaderWrapperStyle}>
                <Loader size="lg" />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    }
});

const loaderWrapperStyle = css({
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";

interface IProps {
    isOpen: boolean;
    overlayVariant?: IModalOverlayVariant;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowLoadingModal = (props: IProps) => {
    const {isOpen, overlayVariant, zIndex} = props;

    return (
        <Modal isOpen={isOpen} className={modalStyle} showCloseButton={false} overlayVariant={overlayVariant} {...(zIndex === undefined ? {} : {zIndex})}>
            <Modal.Content className={loaderWrapperStyle}>
                <Loader size="lg" />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    }
});

const loaderWrapperStyle = css({
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
